<template>
    <div class="edit-balance">
        <form @submit.prevent="deposit" class="main-form">
            <custom-input 
                v-model="depositAmount"
                inputType="number"
                @clear="depositAmount = ''"
                isRequired
                :title="$t('ACCOUNT_CARDS__DEPOSIT_AMOUNT')"
            />
            <button class="btn">Deposit</button>
        </form>
        <form @submit.prevent="withdraw" v-if="isSupervisor" class="main-form">
            <custom-input 
                v-model="withdrawAmount"
                inputType="number"
                @clear="withdrawAmount = ''"
                isRequired
                :title="$t('ACCOUNT_CARDS__WITHDRAW_AMOUNT')"
            />
            <button class="btn btn-red">{{ $t('ACCOUNT_CARDS__WITHDRAW') }}</button>
        </form>
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput,
    },
    props: {
        cardID: Number,
    },
    data() {
        return {
            depositAmount: '',
            withdrawAmount: '',
        }
    },
    methods: {
        deposit() {
            axios
                .post('WebShop/EditUserBalance', {
                    cardId: this.cardID,
                    amount: this.depositAmount,
                    allowNegativeBalance: false,
                })
                .then(resp => {
                    if(resp.data.status == 1) {
                        this.depositAmount = ''
                        this.$emit('showMessage', {
                            purpose: 'success',
                            text: 'Deposit Is Successful!'
                        })
                    }
                    else {
                        this.showError(resp.data.status)
                    }
                })
                .catch(() => this.showError())
        },
        withdraw(){
            axios
                .post('WebShop/EditUserBalance', {
                    cardId: this.cardID,
                    amount: this.withdrawAmount * -1,
                    allowNegativeBalance: true,
                })
                .then(resp => {
                    if(resp.data.status == 1) {
                        this.withdrawAmount = ''
                        this.$emit('showMessage', {
                            purpose: 'success',
                            text: 'Withdraw Is Successful!'
                        })
                    }
                    else {
                        this.showError(resp.data.status)
                    }
                })
                .catch(() => this.showError())
        },
        showError(status) {
            var text = 'An Error Occurred!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) text = code.value
            this.$emit('showMessage', {
                purpose: 'error',
                text: text,
            })
        }
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        statusCodes() {
            return this.$store.state.statusCodes
        }
    }
}
</script>

<style scoped lang="scss">
.edit-balance {
    margin-top: 100 * $rem;
}
form {
    display: flex;
    margin-top: 30 * $rem;
    align-items: center;

    /deep/ label {
        margin-right: 15 * $rem;
        width: 220 * $rem;
    }

    .btn {
        width: 150 * $rem;
        height: 40 * $rem;
        font-size: 16 * $rem;
    }
}

@media only screen and (max-width: 345px) {
    .edit-balance {
        margin-top: 0;
    }
}
</style>
